import React from "react";
import { auth } from "services";
import useUniversalStore from "store/universalStore";

const EmailVerify = () => {
    const user = useUniversalStore((state) => state.user);

    const verifyEmailHandler = async (e) => {
        e.preventDefault();
        const result = await auth.sendVerificationEmail(user.get("email"));
        console.log(result);
        // success(result);
        // failure(cause);
        // }).catch((cause) => {
        //   failure(cause);
        // })
    }

    return (
        <>
            {user?.get('emailVerified') ? (
                <div className="mt-2 text-success">
                    <i className="bi bi-patch-check-fill"></i>{' '}
                    Email Verified!
                </div>
            ) : (
                <div className="mt-2 d-flex flex-column flex-md-row align-items-end align-items-md-center justify-content-md-end gap-2 text-app">
                    <span className="me-md-3">
                        <i className="bi bi-shield-fill-exclamation"></i>{' '}
                        Email not verified!
                    </span>
                    <button onClick={verifyEmailHandler}
                        className="btn btn-sm btn-outline-app">
                        Send verification Email
                    </button>
                </div>
            )}
        </>
    )
}

export default EmailVerify;